import AffiliatedFacPhyAPI from '../../../APIs/LoginAPI/AffiliatedFacPhyAPI'

export const hospClinDoc = {
    state: {
        hospClin: [],
        specializations: [],
        doctors: [],
        doctor_dialog: [],
        hospClin_dialog: []
    },
    actions: {
    // Display all Hospitals/Clinics
        hospClin({ commit }, facilityType) {
            AffiliatedFacPhyAPI.hospClin(facilityType).then((res) => {
                commit('HOSP_CLIN', res.data)
            })
        },

        // Display Hospital/Clinic Dialog
        async hospClinDialog({ commit }, facilityData) {
            await AffiliatedFacPhyAPI.hospClinDialog(facilityData).then((res) => {
                commit('HOSP_CLIN_DIALOG', res.data)
            })
        },

        // Doctor's Specializations
        specializations({ commit }) {
            AffiliatedFacPhyAPI.specializations().then((res) => {
                commit('SPECIALIZATIONS', res.data)
            })
        },

        // Display all Doctors
        doctors({ commit }, docSpecialization) {
            AffiliatedFacPhyAPI.doctors(docSpecialization).then((res) => {
                commit('DOCTORS', res.data)
            })
        },

        // Display Doctors Dialog
        async doctorsDialog({ commit }, doctorName) {
            await AffiliatedFacPhyAPI.doctorsDialog(doctorName).then((res) => {
                commit('DOCTOR_DIALOG', res.data)
            })
        }
    },
    mutations: {
        HOSP_CLIN(state, hospClin) {
            state.hospClin = hospClin
        },
        HOSP_CLIN_DIALOG(state, hospClin_dialog) {
            state.hospClin_dialog = hospClin_dialog
        },
        SPECIALIZATIONS(state, specializations) {
            state.specializations = specializations
        },
        DOCTORS(state, doctors) {
            state.doctors = doctors
        },
        DOCTOR_DIALOG(state, doctor_dialog) {
            state.doctor_dialog = doctor_dialog
        }
    },
    getters: {
        getHospClin(state) {
            return state.hospClin
        },
        getHospClinDialog(state) {
            return state.hospClin_dialog
        },
        getSpecializations(state) {
            return state.specializations
        },
        getDoctors(state) {
            return state.doctors
        },
        getDoctorDialog(state) {
            return state.doctor_dialog
        }
    }
}
